<template>
  <!-- 下属机构管理 -->
  <div class="edu_pages">
    <div class="edu_pages_content_box">
      <div class="edu_page_title_box">
        <div class="title_box">
          <div class="color_lump_box"></div>
          <span>下属机构管理</span>
        </div>
        <div class="edu_operation_box">
          <el-input
            size="mini"
            style="width:200px"
            placeholder="请输入机构名称"
            v-model.trim="listRequestData.eduBuresuName"
            clearable
            @keyup.enter.native="searchData()"
          >
          </el-input>
          <div class="search_icon_box button-box" @click="searchData()">
            <div></div>
            <span>搜索</span>
          </div>
          <div class="add_icon_box button-box" @click="openAddBox()">
            <div></div>
            <span>新增</span>
          </div>
        </div>
      </div>

      <div class="edu_pages_content_body_box">
        <div class="edu_table_box">
          <el-table
            :data="dataList.list"
            height="100%"
            :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
            class="table_box"
          >
            <el-table-column label="序号" width="70" align="center">
              <template slot-scope="scope">
                {{
                  listRequestData.pageSize * (listRequestData.pageNum - 1) +
                    scope.$index +
                    1
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="eduBuresuName"
              label="机构名称"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="regionName"
              label="行政区域"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="contactAddress"
              label="机构地址"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="organizationCode"
              label="机构代码"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <!-- <el-table-column prop="addTime" label="创建日期" width="100">
                    </el-table-column> -->
            <el-table-column
              prop="status"
              label="状态"
              width="120"
              align="center"
            >
              <template slot-scope="rowData">
                <el-tag
                  type="warning"
                  v-if="rowData.row.status == 0"
                  effect="plain"
                >
                  启用
                </el-tag>
                <el-tag type="danger" v-else effect="plain">
                  禁用
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="rowData">
                <el-link
                  type="primary"
                  @click="getDataOne(rowData.row.eduId)"
                  :underline="false"
                  >编辑</el-link
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="edu_pagination_box">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            :current-page="dataList.pageNum"
            :page-size="listRequestData.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="dataList.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      :title="type == 'add' ? '新增下属机构信息' : '编辑下属机构信息'"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      :visible.sync="actionDataBox"
      width="40%"
    >
      <div class="dialog_box">
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="actionDataInfo"
          label-width="0px"
        >
          <div class="form-row-item-box">
            <div class="form-item-box">
              <span>行政区域:</span>
              <el-form-item prop="regionCode">
                <el-select
                  size="small"
                  style="width:100%"
                  :disabled="type == 'add' ? false : true"
                  v-model="actionDataInfo.regionCode"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in regionList"
                    :key="index"
                    :label="item.regionName"
                    :value="item.regionCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="form-item-box">
              <span>机构名称:</span>
              <el-form-item prop="eduBuresuName">
                <el-input
                  size="small"
                  clearable
                  style="width:100%"
                  v-model.trim="actionDataInfo.eduBuresuName"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-row-item-box">
            <div class="form-item-box">
              <span>机构类型:</span>
              <el-form-item>
                <el-radio-group
                  size="small"
                  v-model="actionDataInfo.eduBuresuType"
                >
                  <el-radio
                    v-for="typeList in institutionType"
                    :key="typeList.id"
                    :value="typeList.id"
                    :label="typeList.id"
                    >{{ typeList.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="form-item-box">
              <span>状态:</span>
              <el-form-item>
                <el-radio-group size="small" v-model="actionDataInfo.status">
                  <el-radio
                    v-for="statusList in $store.state.select.institutionStatus"
                    :key="statusList.id"
                    :value="statusList.id"
                    :label="statusList.id"
                    >{{ statusList.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
          <div class="form-row-item-box">
            <div class="form-item-box">
              <span>总负责人:</span>
              <el-form-item prop="director">
                <el-input
                  size="small"
                  clearable
                  style="width:100%"
                  v-model.trim="actionDataInfo.director"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-item-box">
              <span>职工人数:</span>
              <el-form-item prop="workersAmount">
                <el-input
                  size="small"
                  clearable
                  style="width:100%"
                  v-model.trim="actionDataInfo.workersAmount"
                >
                  <template slot="append">人</template></el-input
                >
              </el-form-item>
            </div>
          </div>
          <div class="form-row-item-box">
            <div class="form-item-box">
              <span>安全负责人:</span>
              <el-form-item prop="safetyManager">
                <el-input
                  size="small"
                  clearable
                  style="width:100%"
                  v-model.trim="actionDataInfo.safetyManager"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-item-box">
              <span>联系方式:</span>
              <el-form-item prop="phone">
                <el-input
                  size="small"
                  clearable
                  style="width:100%"
                  v-model.trim="actionDataInfo.phone"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-row-item-box">
            <div class="form-item-box" style="width:100%">
              <span>机构地址:</span>
              <el-form-item prop="contactAddress">
                <el-input
                  size="small"
                  clearable
                  autosize
                  type="textarea"
                  style="width:100%"
                  v-model.trim="actionDataInfo.contactAddress"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-row-item-box">
            <div class="form-item-box" style="width:100%">
              <span>地图选择器:</span>
              <el-form-item>
                <subord-map
                  :actionDataBox="actionDataBox"
                  :lngLat="actionDataInfo.eduCoordinate"
                  @getLngLat="getLngLat($event)"
                ></subord-map>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="dialog_save_cancel_box">
          <div class="cancel_item_box" @click="handleClose">取消</div>
          <div class="save_item_box" @click="saveClick('ruleForm')">确定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import regionSelect from "./components/regionSelect";
import subordMap from "./components/subordMap";
export default {
  name: "",
  components: {
    // regionSelect,
    subordMap
  },
  props: {},
  data() {
    var num = /^[0-9]*[1-9][0-9]*$/;
    var checkNum = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!num.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
      actionDataBox: false,
      listRequestData: {
        eduId: this.$store.getters.getEduData.eduId,
        pageNum: 1,
        pageSize: 20,
        eduBuresuName: ""
      },
      dataList: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },
      regionList: [
        {
          regionName: "",
          regionCode: ""
        }
      ],
      actionDataInfo: {
        eduId: 0,
        eduBuresuName: "",
        director: "",
        workersAmount: "",
        contactAddress: "",
        organizationCode: "",
        safetyManager: "",
        phone: "",
        eduBuresuType:
          JSON.parse(sessionStorage.getItem("eduInfo")).eduBuresuType + 1,
        regionCode: "",
        status: 0,
        parEduId: this.$store.getters.getEduData.eduId,
        // parEduId: "",
        eduCoordinate: ""
      },
      type: "add",
      addResize: 0,
      rules: {
        regionCode: [{ required: true, message: " ", trigger: "change" }],
        eduBuresuName: [{ required: true, message: " ", trigger: "blur" }],
        director: [{ required: true, message: " ", trigger: "blur" }],
        workersAmount: [
          { required: true, validator: checkNum, trigger: "blur" }
        ],
        safetyManager: [{ required: true, message: " ", trigger: "blur" }],
        phone: [{ required: true, message: " ", trigger: "blur" }],
        contactAddress: [{ required: true, message: " ", trigger: "blur" }]
      }
    };
  },
  watch: {},
  methods: {
    clearData() {
      this.actionDataInfo = {
        eduId: 0,
        eduBuresuName: "",
        director: "",
        workersAmount: "",
        contactAddress: "",
        organizationCode: "",
        safetyManager: "",
        phone: "",
        eduBuresuType: this.eduInfo.eduBuresuType + 1,
        regionCode: "",
        status: 0,
        parEduId: this.$store.getters.getEduData.eduId,
        // parEduId: "",
        eduCoordinate: ""
      };
    },
    // 获取子组件传来的经纬度字符串
    getLngLat(lngLat) {
      // console.log(lngLat)
      this.actionDataInfo.eduCoordinate = lngLat;
    },

    openAddBox() {
      this.actionDataBox = true;
      this.type = "add";
      // this.addResize++;
      // this.initmap()
      this.getSubRegionList();
    },
    cancelForm() {
      this.actionDataBox = false;
      this.clearData();
    },
    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.actionDataBox = false;
      this.clearData();
    },
    searchData() {
      this.listRequestData.pageNum = 1;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.listRequestData.pageNum = val;
      console.log(`当前页: ${val}`);
      this.getDataList();
    },
    saveClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sendEduData();
        } else {
          return false;
        }
      });
    },
    // 发送教育局数据  编辑
    async sendEduData() {
      var requestData = {};
      var requestData = JSON.parse(JSON.stringify(this.actionDataInfo));
      if (requestData.eduId == 0) {
        delete requestData.eduId;
      }
      let res = await this.$Http.sendEduData(requestData, true);
      if (res.code == 200) {
        this.actionDataInfo.eduId = 0;
        this.actionDataInfo.regionName = "";
        this.actionDataInfo.eduBuresuName = "";
        this.actionDataInfo.director = "";
        this.actionDataInfo.workersAmount = "";
        this.actionDataInfo.contactAddress = "";
        this.actionDataInfo.organizationCode = "";
        this.actionDataInfo.safetyManager = "";
        this.actionDataInfo.phone = "";
        this.actionDataInfo.eduBuresuType = this.eduInfo.eduBuresuType + 1;
        this.actionDataInfo.regionCode = "";
        this.actionDataInfo.status = 0;
        this.actionDataInfo.eduCoordinate = "";
        this.cancelForm();
        this.getDataList();
        this.$message({
          message: res.messsage,
          type: "success"
        });
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    async getDataOne(id) {
      var requestData = {
        eduId: id
      };
      let res = await this.$Http.getEduInfo(requestData);
      if (res.code == 200) {
        var eduInfo = res.data;

        this.actionDataInfo.eduId = eduInfo.eduId;
        this.actionDataInfo.regionName = eduInfo.regionName;
        this.actionDataInfo.eduBuresuName = eduInfo.eduBuresuName;
        this.actionDataInfo.director = eduInfo.director;
        this.actionDataInfo.workersAmount = eduInfo.workersAmount;
        this.actionDataInfo.contactAddress = eduInfo.contactAddress;
        this.actionDataInfo.organizationCode = eduInfo.organizationCode;
        this.actionDataInfo.safetyManager = eduInfo.safetyManager;
        this.actionDataInfo.phone = eduInfo.phone;
        this.actionDataInfo.eduBuresuType = eduInfo.eduBuresuType;
        this.actionDataInfo.regionCode = eduInfo.regionCode + "";
        this.actionDataInfo.status = eduInfo.status;
        this.actionDataInfo.eduCoordinate = eduInfo.eduCoordinate;
        this.actionDataInfo.parEduId = eduInfo.parEduId;

        this.actionDataBox = true;
        this.type = "edit";
        // this.addResize++;

        // actionDataInfo:{
        //     eduId:0,
        //     eduBuresuName:'',
        //     director:'',
        //     workersAmount:'',
        //     contactAddress:'',
        //     organizationCode:'',
        //     safetyManager:'',
        //     phone:'',
        //     eduBuresuType:'',
        //     regionCode:'',
        //     status:0,
        //     parEduId:this.$store.getters.getEduData.eduId,
        //     eduCoordinate:'',
        // },
        // console.log(eduInfo);
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    async getSubRegionList() {
      let eduInfo = JSON.parse(sessionStorage.getItem("eduInfo"));
      let req = {
        regionCode: eduInfo.regionCode,
        curRegionCode: eduInfo.regionCode
      };
      let res = await this.$Http.getRegionList(req);
      if (res.code == 200) {
        this.regionList = res.data || [];
      } else if (res.code == 101) {
        this.regionList = [];
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    async getDataList() {
      let res = await this.$Http.getEduList(this.listRequestData);
      if (res.code == 200) {
        this.dataList.pageSize = res.data.pageSize;
        this.dataList.pageNum = res.data.pageNum;
        this.dataList.total = res.data.total;
        this.dataList.pages = res.data.pages;
        this.dataList.list = res.data.list;
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    }
  },
  created() {
    // console.log(this.$store.getters.getEduData)
    this.getDataList();
  },
  mounted() {},
  computed: {
    institutionType() {
      if (this.eduInfo.eduBuresuType == 0) {
        return [
          { id: 1, name: "市机构" },
          { id: 2, name: "区县机构" },
          { id: 3, name: "乡镇机构" }
        ];
      } else if (this.eduInfo.eduBuresuType == 1) {
        return [
          { id: 2, name: "区县机构" },
          { id: 3, name: "乡镇机构" }
        ];
      } else {
        return [{ id: 3, name: "乡镇机构" }];
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import "../../../../public/css/edu_pages.scss";
</style>
